import {ImageRequestParams} from "../models/image/image-request-params";

export class BackImageRequestParams extends ImageRequestParams {
  constructor(width, height, color) {
    super({width, height, color});

    this._resourceName = `bolao26/Icons/Back_Icon`;
    this.ratio = 3;
  }
}
